import ResizeObserver from 'resize-observer-polyfill';
import {
  add,
  contains,
  listen,
  qs,
  qsa,
  remove,
  toggle,
} from '@fluorescent/dom';

import { section } from '@/glow';
import { on } from '@/glow/events';
import { preventDefault } from '@/utils';

import QuickCart from '@/lib/header/quick-cart';
import QuickSearch from '@/lib/header/quick-search';
import Navigation from '@/lib/header/navigation';
import Menu from '@/lib/header/drawer-menu';

function setHeaderHeightVar(height) {
  document.documentElement.style.setProperty('--height-header', height + 'px');
}

section('header', {
  onLoad() {
    const { enableStickyHeader } = this.container.dataset;
    const cartIcon = qs('[data-js-cart-icon]', this.container);
    const cartIndicator = qs('[data-js-cart-indicator]', cartIcon);
    const count = qs('[data-js-cart-count]', this.container);
    const menuButtons = qsa('[data-js-menu-button]', this.container);
    const searchButtons = qsa('[data-search]', this.container);
    const space = qs('[data-header-space]', document);

    const menu = Menu(qs('[data-drawer-menu]'));
    const quickSearch = QuickSearch(qs('[data-quick-search]', this.container));
    const quickCart = QuickCart(qs('[data-quick-cart]', this.container));
    const navigation = Navigation(qs('[data-navigation]', this.container));

    // These all return a function for cleanup
    this.listeners = [
      on('cart:updated', ({ cart }) => {
        remove(cartIndicator, 'visible');
        setTimeout(() => add(cartIndicator, 'visible'), 500);
        count.innerHTML = cart.item_count;
      }),

      listen(menuButtons, 'click', preventDefault(menu.open)),
      listen(searchButtons, 'click', preventDefault(quickSearch.open)),
      listen(cartIcon, 'click', preventDefault(quickCart.open)),
    ];

    // Components return a destroy function for cleanup
    this.components = [menu, quickSearch, quickCart];

    // navigation only exists if the header style is Inline links
    navigation && this.components.push(navigation);

    if (enableStickyHeader) {
      // Our header is always sticky (with position: sticky) however at some
      // point we want to adjust the styling (eg. box-shadow) so we toggle
      // the is-sticky class when our arbitrary space element (.header__space)
      // goes in and out of the viewport.
      this.io = new IntersectionObserver(([{ isIntersecting: visible }]) => {
        toggle(this.container, 'is-sticky', !visible);
      });
      this.io.observe(space);
    }

    // This will watch the height of the header and update the --height-header
    // css variable when necessary. That var gets used for the negative top margin
    // to render the page body under the transparent header
    this.ro = new ResizeObserver(([{ target }]) => {
      if (!contains(target, 'is-sticky')) {
        setHeaderHeightVar(target.offsetHeight);
      }
    });
    this.ro.observe(this.container);
  },

  onUnload() {
    this.listeners.forEach(l => l());
    this.components.forEach(c => c.destroy());

    this.io && this.io.disconnect();
    this.ro.disconnect();
  },
});
